<template>
  <!-- 使用el-table，增加配置字段显示功能，与YqTableColumn一起使用，如果没有设置页面pageName，无法正常显示,可能会有显示bug，使用showDataColumns进行刷新，可以调用formatData进行数据格式更新，用于懒加载 -->
  <div class="yq-table" :class="height === 'auto'?'yq-table-auto': ''" :style="{'--height': height}">
    <el-table v-if="displayTable" :data="dataList" stripe border height="inherit" ref="eleTable"
              @rowDblclick="rowDblclick" @selectionChange="$emit('selectionChange', $event)" @rowClick="rowClick"
              :highlight-current-row="highlightCurrentRow" :current-row-key="currentRowKey" row-key="id" lazy :load="load" :default-expand-all="defaultExpandAll"
              :empty-text="emptyText"
    >
      <template #empty>
        <slot name="empty"></slot>
      </template>
      <el-table-column type="index" align="center" fixed="left" :width="60">
        <template #header>
          <span class="icon-setting">
            <yq-icon name="element-ui_setting" v-if="settingDisabled" class="icon-setting-disabled" style="color: var(--el-color-info)"/>
            <yq-icon name="element-ui_setting" style="color: var(--el-color-primary)" v-else @click="toShowSetting"/>
          </span>
        </template>
      </el-table-column>
      <slot></slot>
      <el-table-column v-for="(t, id) in dynamicColumns" :min-width="120" :key="id" :width="t.width" :prop="t.props" :label="t.rename || t.label" :align="t.align" :class-name="t.className" :fixed="t.fixed" :show-overflow-tooltip="true">
        <template v-slot="{row}">
          <custom-column-table-display :data="row" :setting="customColumnListOriginal" :prop-column="t.props" />
        </template>
      </el-table-column>
    </el-table>
    <el-dialog dialog-width="3" v-model="showSetting" :title="$t('message.setColumnName')" append-to-body>
      <dialog-table>
        <separate-page v-if="enableCustomerTable" :show-border="true" :show-shadow="false">
          <template #category>
            <div class="customer-tree" :class="{'active': item.id === currentCategory}" v-for="(item, idx) in selfColumns" :key="idx" @click="clickCategory(item)">
              <span>{{item.formName}}</span>
            </div>
          </template>
          <template #default>
            <el-table class="dialog-table-border" :data="settingList" stripe border id="dragTable" v-loading="loadingSetting">
              <el-table-column type="index" :label="$t('message.indexName')" :width="60" align="center"/>
              <el-table-column prop="label" :label="$t('message.columnName')" :show-overflow-tooltip="true">
                <template v-slot="{row}">{{row.label}}</template>
              </el-table-column>
              <el-table-column :label="$t('message.rename')">
                <template v-slot="{row}">
                  <el-input v-model="row.rename" :placeholder="row.label"  :disabled="row.required"/>
                </template>
              </el-table-column>
              <el-table-column label="宽度">
                <template v-slot="{row}">
                  <el-input v-model="row.width" placeholder="表格的宽度"  :disabled="row.required"/>
                </template>
              </el-table-column>
              <!--              <el-table-column label="顺序">-->
              <!--                <template v-slot="{row}">-->
              <!--                  <el-input v-model="row.index" placeholder="表格的顺序"/>-->
              <!--                </template>-->
              <!--              </el-table-column>-->
              <el-table-column label="对齐">
                <template v-slot="{row}">
                  <el-select v-model="row.align"  :disabled="row.required">
                    <el-option label="向左对齐" value="left"/>
                    <el-option label="向右对齐" value="right"/>
                    <el-option label="居中对齐" value="center"/>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="是否固定">
                <template v-slot="{row}">
                  <el-select v-model="row.fixed" :disabled="row.required">
                    <el-option label="不固定" :value="false"/>
                    <el-option label="左侧固定" value="left"/>
                    <el-option label="右侧固定" value="right"/>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column :label="$t('message.displayOrNot')" align="center" :width="120">
                <template v-slot="{row}">
                  <el-switch :disabled="row.checkedAble === false" v-model="row.checked" active-color="#13ce66" inactive-color="#ff4949" />
                </template>
              </el-table-column>

            </el-table>
          </template>
        </separate-page>
        <el-table v-else class="dialog-table-border" :data="settingList" stripe border id="dragTable">
          <el-table-column type="index" :label="$t('message.indexName')" :width="60" align="center"/>
          <el-table-column prop="label" :label="$t('message.columnName')" :show-overflow-tooltip="true">
            <template v-slot="{row}">{{row.label}}</template>
          </el-table-column>
          <el-table-column :label="$t('message.rename')">
            <template v-slot="{row}">
              <el-input v-model="row.rename" :placeholder="row.label"/>
            </template>
          </el-table-column>
          <el-table-column label="宽度">
            <template v-slot="{row}">
              <el-input v-model="row.width" placeholder="表格的宽度"/>
            </template>
          </el-table-column>
          <!--          <el-table-column label="顺序">-->
          <!--            <template v-slot="{row}">-->
          <!--              <el-input v-model="row.index" placeholder="表格的顺序"/>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <el-table-column label="对齐">
            <template v-slot="{row}">
              <el-select v-model="row.align">
                <el-option label="向左对齐" value="left"/>
                <el-option label="向右对齐" value="right"/>
                <el-option label="居中对齐" value="center"/>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="是否固定">
            <template v-slot="{row}">
              <el-select v-model="row.fixed">
                <el-option label="不固定" :value="false"/>
                <el-option label="左侧固定" value="left"/>
                <el-option label="右侧固定" value="right"/>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column :label="$t('message.displayOrNot')" align="center" :width="120">
            <template v-slot="{row}">
              <el-switch v-model="row.checked" active-color="#13ce66" inactive-color="#ff4949" />
            </template>
          </el-table-column>
        </el-table>
      </dialog-table>
      <div slot="footer" style="text-align: right">
        <el-button @click="showSetting = false">{{$t("message.cancelData")}}</el-button>
        <el-button type="primary" @click="changeSetting(true)">{{$t("message.confirmData")}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import util from "@/util/util";
import commonApi from "@/api/commonApi";
import DialogTable from "@/components/h5/layout/DialogTable.vue";
import SeparatePage from "@/components/h5/layout/SeparatorPage.vue";
import {watch} from "vue";
import FormItems from "@/components/h5/layout/FormItems.vue";
import FormItem from "@/components/h5/layout/FormItem.vue";
import CustomColumnTableDisplay from "@/components/h5/data/CustomColumnTableDisplay.vue";
/** 数据响应不及时，可以使用 showDataColumns 进行刷新*/
export default {
  emits: ["selectionChange", "rowClick", "rowDblclick"],
  props: {
    data: {default: () => []},
    appName: {default: ""}, // 业务应用
    pageName: {default: ""}, // 页面名称
    // 以下是el-table属性
    highlightCurrentRow: {default: ""},
    rowKey: {default: ""},
    lazy: {default: false},
    currentRowKey: {default: ""},
    load: {default: null},
    defaultExpandAll: {default: false},
    height: {default: "100%"},
    emptyText: {default: "暂无数据"},
  },
  name: "",
  components: {
    SeparatePage, DialogTable, FormItems, FormItem, CustomColumnTableDisplay
  },
  data() {
    return {
      dataList: [], // 列表的数据
      settingDisabled: false,

      sessionKey: "userColumnSetting", // 前端缓存的key
      savedList: [], // 保存在后端的数据
      hasDynamicColumn: false, // 是否有自定义字段
      selfColumns: [
        {formName: "全部", dynamicCode: "all", id: "0"},
        {formName: "系统标准字段", dynamicCode: "systemDefault", id: "-1"},
        {formName: "自定义字段", dynamicCode: "customColumn", id: "1"},
      ], // 自定义的字段列表
      currentCategory: "-1", // 当前选中的分类
      settingList: [], // 显示在页面，进行配置操作的项
      showSetting: false,
      dynamicColumns: [], // 自定义的字段
      settingId: "",
      displayTable: true,
      currentIndex: 0, // 当前的顺序
      enableCustomerTable: false, // 是否支持自定义表格
      currentCustomerColumn: {}, // 当前的自定义字段
      loadingSetting: false, // 正在加载中
      savedListDb: [], // 保存在后端的数据
      tableColumns: [], // 从tableColumn中注册的字段,写在vue里面的字段
      customColumnList: [], // 自定义的字段列表
      customColumnListOriginal: [], // 自定义的字段列表,原始数据
    };
  },
  created() {
    this.savedList = [];
    watch(() => this.data, () => {
      this.showDataColumns()
    },)
    if (!this.pageName) {
      this.settingDisabled = true;
    }
  },
  mounted() {
    // 哪些字段显示，哪些字段隐藏
    // 获取配置信息
    this.initTable();
  },
  methods: {
    // 加载自定义字段,是否支持自定义
    initCustomerColumn() {
      return new Promise(resolve => {
        if (this.appName && this.pageName) { // 有业务应用和页面名称，查询是否支持自定义字段
          commonApi.queryCustomerTableAble({appName: this.appName, pageName: this.pageName}).then(res => {
            this.enableCustomerTable = res === "1";
            resolve();
          });
        } else {
          resolve();
        }
      })
    },
    getTable() {
      return this.$refs.eleTable;
    },
    rowClick(row, column, event) {
      this.$emit("rowClick", row, column, event);
    },
    rowDblclick(row, column, event) {
      this.$emit("rowDblclick", row, column, event);
    },
    async initTable() {
      if (!this.pageName) { // 不支持自定义显示功能
        this.settingDataConcat(this.savedListDb, this.tableColumns, true); // vue注入的字段,显示在列表中
        this.showDataColumns(); // 显示字段
        return;
      }
      this.loadingSetting = true;
      // 1 加载已保存的数据，2加载vue中添加进去的字段
      await this.loadSavedAndSystemParams();
      // 3 加载自定义字段,是否支持自定义
      await this.initCustomerColumn();
      console.log(this.enableCustomerTable, "支持自定义？？？？")
      if (this.enableCustomerTable) { // 支持自定义
        await this.loadCustomColumn(); // 3 加载自定义字段
      }
      // 组装数据，要在页面显示的数据，保存在savedList中，由vue注入的字段和自定义字段两部分组成
      this.savedList = [];
      this.settingDataConcat(this.savedListDb, this.tableColumns, true); // vue注入的字段,显示在列表中
      this.settingDataConcat(this.savedListDb, this.customColumnList, false); // 自定义的字段,显示在列表中
      this.loadingSetting = false;
      this.showDataColumns(); // 显示字段
    },
    // 将两个数据合并,将list2的数据，和list1的数据合并成一条数据，保存到savedList中
    settingDataConcat(dbList, targetList, defaultChecked) {
      for (let i = 0; i < targetList.length; i++) {
        let contains = false;
        for (let j = 0; j < dbList.length; j++) {
          if (targetList[i].props === dbList[j].props) { // 找到这个字段
            dbList[j].label = targetList[i].label; // 变更原始名称
            this.savedList.push(dbList[j]);
            contains = true;
            break;
          }
        }
        if (!contains) {
          this.savedList.push(
              {
                ...targetList[i],
                checked: defaultChecked
              });
        }
      }
    },
    // 加载自定义字段
    loadCustomColumn() {
      return new Promise(resolve => {
        commonApi.customerTableList(this.pageName).then(list => {
          this.customColumnListOriginal = list;
          let arr = [];
          for (let i = 0; i < list.length; i++) {
            // 是否允许显示在列表
            if (list[i].columnDisplay === 1) {
              arr.push({
                align: "left",
                checked: false, // 未选中
                checkedAble: true, // 可以被显示在列表
                displayInSetting: true,
                dynamicCode: "customColumn",
                fixed: false,
                index: i,
                id: list[i].id,
                label: list[i].columnLabel,
                props: "customerForm." + list[i].columnName, // 字段名
                required: false,
              });
            }
          }
          this.customColumnList = arr; // 自定义的字段，添加到列表缓存
          resolve();
        })
      })
    },
    // 加载保存在系统中的，个人设置的列表字段, 1 加载数据库中保存的数据，2 加载系统字段，也就是vue加载进来的column
    async loadSavedAndSystemParams() {
      let params = await this.getSettingParams();
      if (params) {
        // 有配置信息
        this.savedListDb = JSON.parse(params);
      }
    },
    // 获取配置信息
    getSettingParams() { // force是否强制刷新
      return new Promise(resolve => {
        let session = util.getSession(this.sessionKey);
        if (session) {
          let paramsArray = JSON.parse(session);
          for (let i = 0; i < paramsArray.length; i++) {
            if (paramsArray[i].pageName === this.pageName) {
              this.settingId = paramsArray[i].id;
              resolve(paramsArray[i].pageParams); // 如果找到数据就返回，如果没有找到数据，就返回一个空
              return;
            }
          }
          resolve(""); // 没有找到数据
        } else {
          commonApi.queryColumnSetting().then(savedList => {
            if (savedList && savedList.length > 0) {
              util.setSession(this.sessionKey, JSON.stringify(savedList)); // 缓存数据
              for (let i = 0; i < savedList.length; i++) {
                if (savedList[i].pageName === this.pageName) {
                  this.settingId = savedList[i].id;
                  resolve(savedList[i].pageParams);
                  break;
                }
              }
            } else {
              resolve("");
            }
          });
        }
      })
    },
    // 按照代码设置的，显示默认字段
    getDefaultColumns() {
      let arr = [];
      for (let i = 0; i < this.tableColumns.length; i++) {
        arr.push({
          ...this.getDefaultColumn2List(this.tableColumns[i]),
          displayInSetting: this.tableColumns[i].displayInSetting,
          dynamicCode: "systemDefault", // 归属到系统标准字段中
        })
      }
      return arr;
    },
    // 把注册进来的column数据，转成列表内的数据
    getDefaultColumn2List(data) {
      return {
        label: data.label,
        props: data.props,
        required: data.required,
        checked: data.required || data.defaultShow, // 是否显示, 如果是required，就显示，否则不显示
        fixed: data.fixed || false,
        width: data.width || "",
        align: data.align || "left",
        index: data.index || 0,
      };
    },
    // 标准化数据，用于懒加载，由于懒加载不会走table，需要手动添加
    formatData(list) {
      let d = {};
      for (let i = 0; i < this.savedList.length; i++) {
        d[this.savedList[i].props] = {
          display: !!this.savedList[i].checked, // 是否显示,
          label: this.savedList[i].rename || this.savedList[i].label,
          fixed: this.savedList[i].fixed || false,
          width: this.savedList[i].width || "",
          align: this.savedList[i].align || "left",
          index: this.savedList[i].index ? parseInt(this.savedList[i].index) : 0,
        };
      }
      this.addDataSetting(list, d);
    },
    // 控制表格字段的显示和隐藏,可手动调用刷新table
    showDataColumns() {
      let d = {};
      // 自定义字段，需要append
      let dynamicColumns = [];
      for (let i = 0; i < this.savedList.length; i++) {
        d[this.savedList[i].props] = {
          display: !!this.savedList[i].checked, // 是否显示,
          label: this.savedList[i].rename || this.savedList[i].label,
          fixed: this.savedList[i].fixed || false,
          width: this.savedList[i].width || "",
          align: this.savedList[i].align || "left",
          index: this.savedList[i].index ? parseInt(this.savedList[i].index) : 0,
        };
        // d[this.savedList[i].props] = !!this.savedList[i].checked;
        if (this.savedList[i].dynamicCode !== "systemDefault" && this.savedList[i].checked) {
          dynamicColumns.push(this.savedList[i]);
        }
      }
      let arr = [...this.data];
      // 将配置信息传递给list
      this.addDataSetting(arr, d);

      this.dataList = arr;
      this.dynamicColumns = dynamicColumns;
      // 刷新页面table显示
      this.displayTable = false;
      this.$nextTick().then(() => this.displayTable = true);
    },
    addDataSetting(list, setting) {
      for (let i = 0; i < list.length; i++) {
        list[i].displaySetting = setting;
        if (list[i].dynamicData) {
          list[i].dynamicDataJson = JSON.parse(list[i].dynamicData);
        }
        if (list[i].children && list[i].children.length > 0) {
          this.addDataSetting(list[i].children, setting);
        }
      }
    },
    // 将自定义字段，添加到全部字段中去
    addSelfColumns2All(arr, selfColumns) {
      // {label: "商品状态", props: "productStatusName", checked: true}, type
      for (let i = 0; i < selfColumns.length; i++) {
        if (selfColumns[i].dynamicInfo) {
          // 有自定义的字段
          let itemArrs = JSON.parse(selfColumns[i].dynamicInfo);
          for (let j = 0; j < itemArrs.length; j++) {
            // 没有这个props才添加
            let props = `dynamicData.${itemArrs[j].userCode}`;
            let contains = false;
            for (let k = 0; k < arr.length; k++) {
              if (arr[k].props === props) {
                contains = true;
                break;
              }
            }
            if (!contains) {
              arr.push({
                label: itemArrs[j].labelName,
                props: `dynamicData.${itemArrs[j].userCode}`,
                dynamicCode: selfColumns[i].dynamicCode,
                dynamicType: itemArrs[j].labelType,
                labelOptions: itemArrs[j].labelOptions,
                required: false, // 非必需字段
              })
            }
          }
        }
        if (selfColumns[i].children && selfColumns[i].children.length > 0) {
          this.addSelfColumns2All(arr, selfColumns[i].children)
        }
      }
    },
    // 注册一个组件，名称，属性，是否必需，默认显示
    registerColumn(data) {
      let contains = false;
      for (let i = 0; i < this.tableColumns.length; i++) {
        if (this.tableColumns[i].props === data.props) {
          contains = true;
          break;
        }
      }
      if (contains) {
        return;
      }
      data.width = data.width ? data.width.replace("rem", "") : "";
      data.index = this.currentIndex++;
      data.dynamicCode = "systemDefault"; // 归属到系统标准字段中
      // 注册后刷新数据
      this.tableColumns.push(data);
    },
    // 保存数据
    changeSetting() {
      let obj = {
        id: this.settingId,
        pageName: this.pageName,
        pageParams: JSON.stringify(this.savedList)
      };
      commonApi.saveColumnSetting(obj).then((data) => {
        this.settingId = data.id;
        this.showDataColumns();
        this.showSetting = false;
        // 保存完了数据，把数据更新到session
        let session = util.getSession(this.sessionKey);
        if (session) {
          session = JSON.parse(session);
        } else {
          session = [];
        }
        let contains = false;
        for (let i = 0; i < session.length; i++) {
          if (session[i].pageName === this.pageName) {
            session[i] = data;
            contains = true;
            break;
          }
        }
        if (!contains) {
          session.push(data);
        }
        util.setSession(this.sessionKey, JSON.stringify(session))

      });
    },
    // 选中某一个分类
    clickCategory(data) {
      this.currentCategory = data.id;
      this.settingList = this.findListByDynamicCode(data.dynamicCode);
    },
    // 显示配置页面
    toShowSetting() {
      // 如果没有自定义字段，就直接显示
      this.settingList = this.findListByDynamicCode("systemDefault");
      this.showSetting = true;
    },
    // 根据code，获取字段，返回列表
    findListByDynamicCode(dynamicCode) {
      if (dynamicCode === 'all') {
        return this.savedList;
      }
      let arr = [];
      for (let i = 0; i < this.savedList.length; i++) {
        if (this.savedList[i].displayInSetting === false) {
          continue;
        }
        if (this.savedList[i].dynamicCode === dynamicCode) {
          arr.push(this.savedList[i])
        }
      }
      return arr;
    },

  }
};
</script>

<style lang="scss" scoped>
.yq-table{
  width: 100%;
  height: var(--height);
  min-width: 0;
  position: relative;
  :deep(.el-table){
    position: absolute;
    height: 100%;
    width: 100% !important;
    th.el-table__cell.is-leaf{
      border-bottom: 1px solid var(--yq-border-color);
    }
  }
}
/*
  自动高度模式（height="auto"）：表格高度由内容撑开，超出时交给外层容器滚动。

  ★ 这里只在保持 .el-table 为普通文档流的前提下工作。
    真正会冒滚动条的是外层 .list-table —— ListPage 里 `.list-page > .list-table`
    写了 `flex: 1; height: 50%`，flex-basis 会盖过标签上的 height: auto，
    把容器压成固定高度，再加上 .list-table 自身的 overflow: auto 就出现滚动条。
    对应的放开规则写在 ListPage.vue 里（用 :has(.yq-table-auto) 精准命中）。

  ★ 不要在 `height="auto"` 模式下加任何 `height: 100%` 的设定 ——
    el-table 模板上写的是 height="inherit"，父容器高度是 auto 时它会拿到字符串 "auto"，
    Element Plus 内部 parseHeight("auto") → Number() 得 NaN，而 updateScrollY()
    只判了 `height === null`，NaN 不等于 null，于是仍按固定高度模式接管滚动。
    保持默认（不设高）才是「无固定高度」的正确路径。
*/
.yq-table-auto{
  :deep(.el-table){
    position: relative;
  }
}
.customer-tree {
  position: relative;
  width: 100%;
  box-sizing: border-box;
  padding: 5px 10px;

  .yq-icon {
    position: absolute;
    right: 10px;
    top: 7px;
    display: none;
  }

  &:hover {
    .yq-icon {
      display: block;
    }
  }

  &.active {
    background: var(--el-color-primary);
    color: #FFF;

    .yq-icon {
      display: block;
    }
  }
}
.option-area{
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
  .select-add{
    border: 1px solid var(--el-color-primary);
    box-sizing: border-box;
    padding: 0 10px;
    border-radius: 4px;
    margin-top: 3px;
    text-align: center;
    color: var(--el-color-primary);
  }
  .select-option{
    position: relative;
    .yq-icon{
      position: absolute;
      right: 10px;
      top: 3px;
      color: var(--el-color-danger);
    }
  }
}
</style>